import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "./settings.initial.state";
import {
	GeneralStringBooleanObjectI,
	GeneralStringObjectI,
	settingsInitialState,
} from "./settings.types";
import { getAppData } from "./settings.actions";

const initState: settingsInitialState = initialState;

const AREA_CODES = Object.freeze({
	no: "47",
	se: "", // "46" - we don't want to show prefix for Sweden
	dk: "45",
});

export const settingsSlice = createSlice({
	name: "settings",
	initialState: initState,
	reducers: {
		showGeneralModal: (
			state,
			action: PayloadAction<{
				title?: string;
				content?: string;
				isHtml?: boolean;
				formattedTitle?: string;
				formattedContent?: string;
			}>,
		) => {
			state.generalModal = {
				visible: true,
				title: action.payload.title,
				content: action.payload.content,
				isHtml: action.payload.isHtml,
				formattedTitle: action.payload.formattedTitle,
				formattedContent: action.payload.formattedContent,
			};
		},
		hideGeneralModal: (state) => {
			state.generalModal = {
				visible: false,
				title: null,
				content: null,
				isHtml: false,
				formattedTitle: null,
				formattedContent: null,
			};
		},
	},
	extraReducers(builder) {
		builder.addCase(getAppData.pending, (state) => {
			state.appReady = false;
		});

		builder.addCase(
			getAppData.fulfilled,
			(
				state,
				action: PayloadAction<{
					locale: string;
					language: string;
					storeId: number;
					country: string;
					isStoreB2B: boolean;
					isCrm: boolean;
					features: GeneralStringBooleanObjectI;
					strings: GeneralStringObjectI;
					validationRules: GeneralStringObjectI;
					privacyPolicyUrl: string;
					vippsLoginLink: string;
					returnUrl: string;
				}>,
			) => {
				state.appReady = true;
				state.features = action.payload.features;
				state.language = action.payload.language;
				state.locale = action.payload.locale;
				state.country = action.payload.country;
				state.storeId = action.payload.storeId;
				state.isStoreB2B = action.payload.isStoreB2B;
				state.isCrm = action.payload.isCrm;
				state.areaCode = AREA_CODES[action.payload.country];
				state.strings = action.payload.strings;
				state.validationRules = action.payload.validationRules;
				state.privacyPolicyUrl = action.payload.privacyPolicyUrl;
				state.vippsLoginLink = action.payload.vippsLoginLink;
				state.returnUrl = action.payload.returnUrl;
			},
		);
		builder.addCase(getAppData.rejected, (state) => {
			state.appReady = false;
		});
	},
});

export const { showGeneralModal, hideGeneralModal } = settingsSlice.actions;
export default settingsSlice.reducer;
